import React, { useEffect } from 'react';
import { Grid, TextField, Button, Link, LinearProgress } from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { Link as LinkRouter, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { hanglePreCheck } from '../../../redux/actions/auth';
import { hangleLogout } from '../../../redux/actions/user';
import { makeStyles } from "@material-ui/core/styles";  
import EmailIcon from '@material-ui/icons/Email';


const useStyles = makeStyles(theme => ({
  root: {
    marginTop: "1em",   
    [theme.breakpoints.down('sm')]: {
      marginTop: "1em",
    },
  }
}));

function PreCheck() {
  const classes = useStyles();
  let history = useHistory();

  const dispatch = useDispatch();
  const { loading, error, data: dataPrecheck } = useSelector( state => state.auth );
  const precheckStatus = dataPrecheck ? dataPrecheck.status : null;

  useEffect(() => {
    // logout :)
    dispatch(hangleLogout());
  }, [dispatch]);  

  const goBack = () => {
    // history.push('/auth/pre-check/');
    window.location.reload();
  }


  const { register, errors, handleSubmit } = useForm({
    // by setting validateCriteriaMode to 'all',
    // all validation errors for single field will display at once
    validateCriteriaMode: "all",
    mode: "onChange"
  });

  const onSubmit = async data => {    
    const {username} = data;

    // AuthService.preCheck(username)
    dispatch(hanglePreCheck(username, history));    
  };

  return (    
    <form noValidate autoComplete="off" onSubmit={handleSubmit(onSubmit)} className={classes.root}>                    
      <Grid item xs={12}>

        {precheckStatus === 'not_activated' && (
          <React.Fragment>
            <Grid item xs={12} style={ {marginTop: "0em"} }>
            <EmailIcon style={{width: "100%", fontSize: "5em"}}/>
            <h3>Activation Required: </h3>
            <p>To complete the activation process, please check your email inbox. We've sent you a message with instructions on how to activate your account. <br/>
            If you don't see the email in your inbox, please check your spam folder. Click the activation link in the email to get started. <br/>
            If you encounter any issues or need assistance, feel free to contact our support team at <a href="mailto:support@flo-ops.com?Subject=I%20need%20help">support@flo-ops.com</a>.</p>
            </Grid>

            <Grid item xs={12} style={ {marginTop: "3em"} }>
              {loading && <LinearProgress /> }
              <Button
                style={ { height: "3em", color: "white", textTransform: "none", fontSize: "1.3em", fontWeight: "bold"} }
                color="primary"
                disabled={loading}
                fullWidth={true}
                variant="contained"
                type="button"
                onClick={goBack}>
                Back
              </Button>                      
            </Grid>

          </React.Fragment>
        )}

        {(loading || precheckStatus === undefined || precheckStatus === 'doesnt_exists') && (
          <React.Fragment>
            <Grid item xs={12} style={ {marginTop: "3em"} }>
              <TextField 
                name="username"
                label="your email"
                placeholder="email@example.com"
                variant="filled"
                fullWidth={true}

                inputRef={register({ required: true, pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                  message: "Invalid email address"
                }})}
                error={errors.username ? true : false}
                helperText={errors.username ? errors.username.message : null}
              />
            </Grid>
      
            <Grid item xs={12} style={ {marginTop: "0.5em"} }>
              <Link 
                component={LinkRouter}
                to={'/auth/forgot-password'}
                > 
                Forgot Your password ?
              </Link>
            </Grid>

            <Grid item xs={12} style={ {marginTop: "0.5em"} }>
              <div style={{position: "relative", width: "100%"}}> 
                <h4 style={ {top: "-1em", position: "abosulte", color: "#f44336", textAlign: "center" } }>{error}</h4>                
              </div>
            </Grid>
            
            {precheckStatus === 'doesnt_exists' && (
              <Grid item xs={12}>
                <p>Username Does Not Exist: <br/>
                Please contact your school IT admin or please email to contact Flo-Ops at: <a href="mailto:support@flo-ops.com?Subject=I%20need%20help">support@flo-ops.com</a>.
                </p>
              </Grid>
            )}

            <Grid item xs={12} style={ {marginTop: "1em"} }>
              {loading && <LinearProgress /> }

              <Button
                style={ { height: "3em", color: "white", textTransform: "none", fontSize: "1.3em", fontWeight: "bold"} }
                color="primary"
                disabled={loading}
                fullWidth={true}
                variant="contained"
                type="submit">
                Next
              </Button>                      
            </Grid>
          </React.Fragment>)}
      </Grid>
    </form>

  )
}

export default PreCheck;